let isLocked = false;

$(document).on('change', '.autosubmit', function () {
    if (isLocked === true) {
        return;
    }
    filterProducts($(this).attr('name'), $(this).val());
});

$(document).on('change', '.autosubmit-check', function () {
    let value = false;
    if ($(this).is(':checked')) {
        value = true;
    }
    filterProducts($(this).attr('name'), value);
});

$(document).on('click', '.autosubmit-click', function (e) {
    e.preventDefault();
    if (isLocked === true) {
        return;
    }
    filterProducts($(this).data('name'), $(this).val());
});

$(document).on('click', '.pager-href', function (e) {
    e.preventDefault();
    if (isLocked === true) {
        return;
    }

    filterProducts('activePage', $(this).data('value'));
    $('html, body').animate({
        scrollTop: $("#category-name").offset().top
    }, 500);
});

function setLocket(state)
{
    if (state === true) {
        $(document).find(".autosubmit-check").attr("disabled", true);
        $(document).find(".autosubmit").attr("disabled", true);
    } else {
        $(document).find(".autosubmit-check").removeAttr("disabled");
        $(document).find(".autosubmit").removeAttr("disabled");
    }
    isLocked = state;
}

function filterProducts(name, value)
{
    setLocket(true);
    let filterData = $(document).find("#filter-data");
    let formData = {};

    let loader = $(document).find('.filter-loader');
    loader.show();
    formData.filter = filterData.data('filter');
    formData.name = name;
    formData.value = value;

    $.nette.ajax({
        url: filterData.data("url"),
        data: formData,
        type: 'POST',
        //processData: false,
        //contentType: false,
        off: {
            snippets: true
        },
        success: function (payload) {
            if (payload.filter) {
                window.history.pushState("", "", ABSOLUTE_URL + "?activeFilter=" + (payload.filter));
            }
            loader.hide();
            setLocket(false);
        },
        error: function (err) {
            loader.hide();
            setLocket(false);
        },
    });
}

$(document).on('click', '.cancel-filter', function (e) {
    e.preventDefault();
    window.location.href = $(this).data('href');
});

$(document).on('click', '.swap-image', function () {
    $(this).closest('.colors-box').find('.active').removeClass('active');
    let product = $(this).closest('.product');
    product.find('.swappable-image').attr("src", $(this).data('image'));
    product.find('.swappable-price').html($(this).data('price'));
    product.find('.swappable-href').attr("href", product.data('base-href') + '/' + $(this).data('slug'));
    $(this).addClass('active');
});


$(document).on('click', '.open-modal-filter', function () {
    let modal = $(document).find('.modal-other-filters');
    modal.find('.loader').show();

    let formData = {};
    let filterData = $(document).find("#filter-data");
    formData.filter = filterData.data('filter');

    $.nette.ajax({
        url: modal.find('.initHandle').data("href"),
        data: formData,
        type: 'POST',
        off: {
            snippets: true
        },
        success: function (payload) {
            modal.find('.loader').hide();
        },
        error: function (err) {
            modal.find('.loader').hide();
        }
    });

    $(document).find('.modal-other-filters').show();
    $(document).find('.overlay').show();
});


$(document).on('click', '.cancel-filter-modal', function (e) {
    e.preventDefault();
    $(document).find('.cancel-filter').click();
});